import React from "react";
import { CreateUserDTO, UserRoles } from "../../types/user.types";
import { ErrorMessage } from "../../components/error-message";
import { Button } from "../../components/button";
import { useTeam } from "../../context/TeamContext";
import { EditableField } from "../../components/editable-field";
import { getAvailableRoles } from "../../utils/available-roles.utils";
import { UsernameField } from "../../components/username-field";

type FormMode = "edit" | "create";
export function UsersForm({
  mode,
  requireTeam,
  onSubmit,
  onCancel,
  isSubmitting,
  currentUserRole,
  usernameApiError,
  onChange,
  formData,
  error,
}: {
  mode: FormMode;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
  isSubmitting: boolean;
  currentUserRole: UserRoles;
  usernameApiError: string | null;
  onChange: (e: React.ChangeEvent<HTMLElement>) => void;
  formData: CreateUserDTO;
  requireTeam: boolean;
  error: string | null;
}) {
  const { teams } = useTeam();

  return (
    <div className="p-4 border border-gray-300 rounded-md">
      <h3 className="text-xl font-bold text-gray-800 mb-4">
        {mode === "edit" ? "Editar Usuario" : "Crear Usuario"}
      </h3>

      <form onSubmit={onSubmit} className="space-y-4">
        <UsernameField
          label="Nombre de Usuario"
          name="username"
          minLength={6}
          maxLength={35}
          value={formData.username}
          onChange={onChange}
          placeholder="Ingrese un nombre de usuario"
          required
          customError={usernameApiError ?? ""}
          apiError={usernameApiError !== null ? "conflict" : undefined}
          title="Solo letras, números, guiones bajos (_) y puntos (.)"
        />

        <EditableField
          label="Rol del Usuario"
          type="select"
          name="role_id"
          value={formData.role_id?.toString()}
          onChange={onChange}
          options={getAvailableRoles(currentUserRole)}
          placeholder="Seleccione un rol"
          required
        />

        {requireTeam && teams && teams.length > 0 && (
          <EditableField
            label="Equipo"
            type="select"
            name="team_id"
            value={formData.team_id?.toString()}
            onChange={onChange}
            options={teams.map((team) => ({
              key: team.team_id.toString(),
              value: team.team_name,
            }))}
            placeholder="Seleccione un equipo"
            required
          />
        )}
        {error && <ErrorMessage message={error} dismissible />}
        <div className="flex justify-end space-x-2 mt-4">
          <Button
            type="button"
            variant="cancel"
            onClick={onCancel}
            text="Cancelar"
          />
          <Button
            type="submit"
            disabled={
              isSubmitting ||
              (requireTeam && !formData.team_id) ||
              usernameApiError !== null ||
              error !== null
            }
            variant="create"
            text={mode === "edit" ? "Guardar" : "Crear"}
          />
        </div>
      </form>
    </div>
  );
}
